import { render, staticRenderFns } from "./ArterHome.vue?vue&type=template&id=1fb12eec&scoped=true&"
import script from "./ArterHome.vue?vue&type=script&lang=js&"
export * from "./ArterHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb12eec",
  null
  
)

export default component.exports